export default __webpack_public_path__ + "static/media/glitch05.93ca10ba.png";